module.exports = __webpack_public_path__ + "static/img/del.fed7260b.png";